


















































































































































































































































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import type { ImportacaoDeNota, ProdutoDaImportacao } from '@/models/ImportacaoDeNota'
import type { Produto } from '@/models'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { FinalizarImportacaoDeNotaDoFornecedorUseCase } from '@/usecases/fornecedor/FinalizarImportacaoDeNotaDoFornecedorUseCase'
import DialogoDeBuscarVinculoDeProdutos from '@/views/application/entradas/DialogoDeBuscarVinculoDeProdutos.vue'
import DialogoDeCriarProduto from '../componentes/DialogoDeCriarProduto.vue'
import { statusDoItem, resumoDaTriagem, aplicarMargemGeral, precoComMargem, problemasDoItem, markupDoFornecedor, agruparNotaAberta, agruparItensManualmente, desagruparItem, similaridadeDescricao } from '@/usecases/importacao-de-notas/importacaoHelpers'

interface ItemConferencia {
	p: ProdutoDaImportacao
	indiceReal: number
}

/**
 * Etapa 2 — conferência/triagem dos itens.
 * Mostra por padrão só o que precisa de ação; vínculo manual reusa o
 * DialogoDeBuscarVinculoDeProdutos do legado.
 */
@Component({
	components: { DialogoDeBuscarVinculoDeProdutos, DialogoDeCriarProduto },
})
export default class EtapaConferencia extends Vue {
	@Prop({ type: Object, default: null }) importacao!: ImportacaoDeNota | null
	@Ref() readonly dialogoDeBuscarVinculoDeProdutos!: { mostrar: (i: number, nome: string, podeCriar: boolean) => void }
	@Ref() readonly dialogoDeCriarProduto!: { mostrar: (item: ProdutoDaImportacao, indice: number, padrao?: any, produtoExistente?: any) => void }

	mostrarSoPendentes = true
	vinculandoLote = false
	selecionados: ItemConferencia[] = []
	margemGeral = 0
	arredondarAbaixo = 0
	arredondarAcima = 0.99
	naoUsarArredondamento = false
	atributosPadrao: any = {}

	private finalizarUseCase = new FinalizarImportacaoDeNotaDoFornecedorUseCase()

	headers = [
		{ text: 'Item da nota', value: 'notaDescricao', sortable: false },
		{ text: 'Produto no catálogo', value: 'catalogo', sortable: false },
		{ text: 'Margem %', value: 'margem', sortable: false },
		{ text: 'Preço venda', value: 'preco', sortable: false },
		{ text: 'Status', value: 'status', sortable: false },
		{ text: 'Ações', value: 'acoes', sortable: false, align: 'end' },
	]

	mounted() {
		if (this.importacao) {
			// Nota aberta: agrupa variantes da mesma referência num só item (idempotente).
			const refs = agruparNotaAberta(this.importacao.produtos)
			if (refs > 0) {
				this.importacao.produtos = [...this.importacao.produtos]
				AlertModule.setInfo(`${refs} referência(s) com variantes foram agrupadas automaticamente.`)
			}
		}
		// Markup do fornecedor sugere a margem geral (igual ao legado).
		const markup = markupDoFornecedor(this.importacao)
		if (markup > 0 && !this.margemGeral) this.margemGeral = markup
	}

	get podeCriarProduto(): boolean {
		const cfg = this.importacao
			&& this.importacao.lojaDestinoDaImportacao
			&& this.importacao.lojaDestinoDaImportacao.configuracaoDaLoja
		return !!(cfg && cfg.criarProdutoImportacaoEntrada)
	}

	get resumo() {
		return resumoDaTriagem(this.importacao ? this.importacao.produtos : [])
	}

	/** Quantidade de itens com aviso de validação — calculado já no carregamento da nota. */
	get totalAvisos(): number {
		if (!this.importacao) return 0
		return this.importacao.produtos.filter(p => !p.isProdutoEstaAgrupado && this.problemas(p).length > 0).length
	}

	get itensVisiveis(): ItemConferencia[] {
		if (!this.importacao) return []
		return this.importacao.produtos
			.map((p, indiceReal) => ({ p, indiceReal }))
			.filter(({ p }) => !p.isProdutoEstaAgrupado)
			.filter(({ p }) => !this.mostrarSoPendentes || statusDoItem(p) === 'pendente')
	}

	statusDoItem(p: ProdutoDaImportacao) {
		return statusDoItem(p)
	}

	formatarQuantidade(qCom: string): string {
		const n = Number(qCom)
		return Number.isFinite(n) ? String(n) : (qCom || '0')
	}

	/** Aplica a margem geral, calculando o preço de venda de todos os itens. */
	aplicarMargem() {
		if (!this.importacao) return
		aplicarMargemGeral(this.importacao.produtos, this.margemGeral, {
			naoUsar: this.naoUsarArredondamento,
			abaixo: this.arredondarAbaixo,
			acima: this.arredondarAcima,
		})
		this.$emit('atualizado')
		this.$forceUpdate()
	}

	atualizarPreco(item: ItemConferencia, valor: any) {
		if (!this.importacao) return
		const preco = Number(valor) || 0
		this.$set(this.importacao.produtos, item.indiceReal, {
			...this.importacao.produtos[item.indiceReal],
			precoFinalVarejo: preco,
		})
	}

	atualizarMargemItem(item: ItemConferencia, valor: any) {
		if (!this.importacao) return
		const margem = Number(valor) || 0
		this.$set(this.importacao.produtos, item.indiceReal, {
			...this.importacao.produtos[item.indiceReal],
			margemDeLucro: margem,
			precoFinalVarejo: precoComMargem(item.p.nota.vUnCom, margem, this.opcoesArredondamento()),
		})
	}

	problemas(p: ProdutoDaImportacao): string[] {
		return this.importacao ? problemasDoItem(p, this.importacao.produtos) : []
	}

	qtdVariantes(p: ProdutoDaImportacao): number {
		return (p.produtosAgrupados as any) ? (p.produtosAgrupados as any).length : 0
	}

	get baseSelecao(): ProdutoDaImportacao | null {
		return this.selecionados.length ? this.selecionados[0].p : null
	}

	private get indicesSelecionados(): Set<number> {
		return new Set(this.selecionados.map(s => s.indiceReal))
	}

	/** Destaca linhas pendentes com descrição parecida com a primeira selecionada. */
	ehSimilar(item: ItemConferencia): boolean {
		if (!this.baseSelecao) return false
		if (this.indicesSelecionados.has(item.indiceReal)) return false
		if (item.p.isProdutoEstaAgrupado || statusDoItem(item.p) !== 'pendente') return false
		return similaridadeDescricao(item.p.nota.xProd, this.baseSelecao.nota.xProd) >= 0.6
	}

	classeDoItem(item: ItemConferencia): string {
		if (this.indicesSelecionados.has(item.indiceReal)) return 'linha-selecionada'
		return this.ehSimilar(item) ? 'linha-similar' : ''
	}

	get totalSimilares(): number {
		return this.itensVisiveis.filter(it => this.ehSimilar(it)).length
	}

	/** Adiciona à seleção todas as linhas parecidas destacadas. */
	selecionarSimilares() {
		const novas = this.itensVisiveis.filter(it => this.ehSimilar(it))
		this.selecionados = [...this.selecionados, ...novas]
	}

	/** Agrupa manualmente os itens selecionados numa referência (independe de cProd/descrição). */
	agruparSelecionados() {
		if (!this.importacao || this.selecionados.length < 2) return
		const ok = agruparItensManualmente(this.selecionados.map(s => s.p))
		if (ok) {
			this.importacao.produtos = [...this.importacao.produtos]
			AlertModule.setSuccess(`${this.selecionados.length} itens agrupados como variantes de uma referência.`)
			this.selecionados = []
		}
	}

	desagrupar(item: ItemConferencia) {
		if (!this.importacao) return
		desagruparItem(this.importacao.produtos, item.p)
		this.importacao.produtos = [...this.importacao.produtos]
		AlertModule.setInfo('Agrupamento desfeito.')
	}

	abrirVinculo(item: ItemConferencia) {
		this.dialogoDeBuscarVinculoDeProdutos.mostrar(item.indiceReal, item.p.nota.xProd, this.podeCriarProduto)
	}

	private opcoesArredondamento() {
		return { naoUsar: this.naoUsarArredondamento, abaixo: this.arredondarAbaixo, acima: this.arredondarAcima }
	}

	abrirCriar(item: ItemConferencia) {
		const precoVenda = precoComMargem(item.p.nota.vUnCom, this.margemGeral, this.opcoesArredondamento())
		this.dialogoDeCriarProduto.mostrar(item.p, item.indiceReal, { ...this.atributosPadrao, precoVenda })
	}

	/** Reabre o diálogo com o produto já criado na importação para ajustar a grade. */
	abrirEditar(item: ItemConferencia) {
		const precoVenda = precoComMargem(item.p.nota.vUnCom, this.margemGeral, this.opcoesArredondamento())
		this.dialogoDeCriarProduto.mostrar(item.p, item.indiceReal, { ...this.atributosPadrao, precoVenda }, item.p.encontrado)
	}

	onProdutoCriado(produto: any, indice: number) {
		if (!this.importacao) return
		// Fase 3: memoriza atributos pra replicar nas próximas criações.
		this.atributosPadrao = {
			marca: produto.marca, genero: produto.genero,
			categoria: produto.categoria, estacao: produto.estacao, tags: produto.tags,
		}
		this.$set(this.importacao.produtos, indice, {
			...this.importacao.produtos[indice],
			encontrado: produto,
			isProdutoComReferenciaCriadaNaImportacao: true,
			criouRelacaoDeProdutoPai: true,
		})
		this.$emit('atualizado')
	}

	/** Fase 3: tenta vincular automaticamente os pendentes por SKU (cProd) e depois por EAN. */
	async vincularAutomaticamente() {
		if (!this.importacao) return
		try {
			this.vinculandoLote = true
			let vinculados = 0
			const pendentes = this.importacao.produtos
				.map((p, i) => ({ p, i }))
				.filter(({ p }) => !p.isProdutoEstaAgrupado && statusDoItem(p) === 'pendente')

			for (const { p, i } of pendentes) {
				let achados = await this.finalizarUseCase.buscarProdutosParaRelacionar(p.nota.cProd, 'sku')
				if ((!achados || !achados.length) && p.nota.cEAN && p.nota.cEAN !== 'SEM GTIN') {
					achados = await this.finalizarUseCase.buscarProdutosParaRelacionar(p.nota.cEAN, 'ean')
				}
				const achado = achados && achados[0]
				if (!achado) continue
				const jaUsado = this.importacao.produtos.some(x =>
					x.encontrado && x.encontrado.id && (x.encontrado.id === achado.id || x.encontrado.sku === achado.sku),
				)
				if (jaUsado) continue
				this.$set(this.importacao.produtos, i, { ...this.importacao.produtos[i], encontrado: achado })
				vinculados++
			}

			if (vinculados > 0) {
				AlertModule.setSuccess(`${vinculados} item(ns) vinculado(s) automaticamente.`)
				this.$emit('atualizado')
			} else {
				AlertModule.setInfo('Nenhum vínculo automático encontrado — use Vincular ou Criar nos pendentes.')
			}
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.vinculandoLote = false
		}
	}

	onProdutoRelacionado(produtos: Produto[], indice: number) {
		if (!this.importacao) return
		const produto = produtos && produtos[0]
		if (!produto) return

		const jaVinculado = this.importacao.produtos.some(p =>
			p.encontrado && p.encontrado.id && (p.encontrado.id === produto.id || p.encontrado.sku === produto.sku),
		)
		if (jaVinculado) {
			AlertModule.setError('Produto já possui vínculo. Desvincule antes de selecionar outro.')
			return
		}

		this.$set(this.importacao.produtos, indice, {
			...this.importacao.produtos[indice],
			encontrado: produto,
		})
		this.$emit('atualizado')
	}

	desvincular(item: ItemConferencia) {
		if (!this.importacao) return
		this.$set(this.importacao.produtos, item.indiceReal, {
			...this.importacao.produtos[item.indiceReal],
			encontrado: null,
			isProdutoComReferenciaCriadaNaImportacao: false,
		})
		this.$emit('atualizado')
	}
}
